import { useAppSelector } from 'common/hooks/redux'
import useGetTemplatesQuery from 'features/unifiedFlow/api/queries/useGetTemplatesQuery'
import { TemplateInfo } from 'features/unifiedFlow/contentsPage/interfaces'

import AddedComponentCard from './AddedComponentCard'

type TemplateInfoWithCount = TemplateInfo & {
  count?: number
}

const AddedComponentList = () => {
  const templatesToAdd = useAppSelector(
    (state) => state.unifiedFlow.templatesToAdd
  )
  const { data: templates } = useGetTemplatesQuery()

  const templatesToAddWithCount: TemplateInfoWithCount[] | undefined = templates
    ?.filter((template) => {
      return templatesToAdd.some((templatetoadd) => {
        return templatetoadd.id === template.id
      })
    })
    .map((template) => {
      const findTemplate = templatesToAdd.find(
        (templatetoadd) => templatetoadd.id === template.id
      )
      return {
        ...template,
        count: findTemplate?.count,
      }
    })

  return (
    <div className="p-6 w-full">
      {templatesToAddWithCount?.map(({ count = 0, ...template }) => {
        return Array.from({ length: count }).map(() => (
          <AddedComponentCard key={template.id} template={template} />
        ))
      })}
    </div>
  )
}

export default AddedComponentList
